module.exports = "/_next/static/images/check_active-f2dbbdaf46ac09301cdcfb428eb96f6b.svg";